var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37933 11.8254L6.10299 11.7122L5.82665 11.8254L0.729 13.9136V1.66667C0.729 1.18331 1.15589 0.729 1.74371 0.729H10.4623C11.0501 0.729 11.477 1.18331 11.477 1.66667V13.9136L6.37933 11.8254Z",
    fill: "#E6E6E6",
    stroke: "#E6E6E6",
    strokeWidth: 1.458
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon-save.03ad1a2dc5aa1c44e90272102444f67a.svg";
export { ForwardRef as ReactComponent };